<template>
  <div class="fm-item" @click="goDes">
    <div class="fm-info">
      <div
        class="fm-cover"
        :style="'background-image: url(' + parsedCover + ')'"
      >
        <img
          class="fm-play"
          src="../../../../images/platform/topicDetail/icon-play.png"
          alt="播放"
        />
      </div>
      <div class="fm-title">
        <div class="title">{{ detailInfo.title }}</div>
        <div class="duration">{{ detailInfo.duration }}</div>
      </div>
    </div>
    <!-- <div class="user-info">
      <div class="avatar">
        <img :src="basicInfo.avatar | imgZip(100)" alt="头像" />
        <span class="name">{{ basicInfo.nickname }}</span>
      </div>
      <div class="level" v-if="firstIdentity">
        <img
          class="icon-level"
          :src="firstIdentity.image | imgZip(54)"
          alt=""
        />
        <span class="level-text">{{ firstIdentity.name }}</span>
      </div>
    </div> -->
    <HandList :info="interactive"></HandList>
  </div>
</template>
<script>
import HandList from 'component/platform/homepage/common/handList.vue'
import { imgZip } from 'app/web/filters/ossImg.js'
import homepageMixin from 'mixins/platfrom/homepageMixin.js'
import { addOssParamsForcibly } from 'utils/tool.js'

export default {
  mixins: [homepageMixin],
  props: {
    fmInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    HandList
  },
  data() {
    return {}
  },
  computed: {
    parsedCover() {
      const { cover } = this.detailInfo
      return addOssParamsForcibly(cover, 255)
    },
    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },
    detailInfo() {
      return this.fmInfo.detail_info || ''
    },
    interactive() {
      return this.fmInfo.interactive || ''
    },
    // 是否专业咨询师
    firstIdentity() {
      return this.$store.getters['homepage/firstIdentity']
    }
  },
  created() {},
  mounted() {},
  methods: {
    imgZip,
    goDes() {
      this.$emit('goDes')
      let url = this.mixinIsApp
        ? `yixinli://open_broadcast?id=${this.detailInfo.id}`
        : `https://static.xinli001.com/msite/index.html#/fm-audio-share?id=${this.detailInfo.id}`
      this.routerPush(url)
    }
  }
}
</script>
<style lang="scss" scoped>
.fm-item {
  padding: 30px;
  margin-bottom: 30px;
  background: #ffffff;
  box-shadow: 0px 0px 40px 0px #ebefff, 0px 0px 40px 0px rgba(0, 0, 0, 0.03);
  border-radius: 30px;
  overflow: hidden;
  .fm-info {
    display: flex;
    justify-content: space-between;
    .fm-cover {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 150px;
      height: 150px;
      border-radius: 20px;
      background-size: cover;
      background-position: center;
      .fm-play {
        width: 80px;
        height: 80px;
        opacity: 0.9;
      }
    }
    .fm-title {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: calc(100% - 170px);
      text-shadow: 0px 0px 40px #ebefff;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #21252d;
        line-height: 57px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .duration {
        font-size: 24px;
        color: #9da3ac;
        line-height: 1.3;
      }
    }
  }
  .user-info {
    display: flex;
    align-items: center;
    margin-top: 26px;
    line-height: 40px;
    .avatar {
      display: flex;
      align-items: center;
      > img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        object-fit: cover;
      }
      .name {
        max-width: 400px;
        margin-left: 10px;
        font-size: 26px;
        color: #21252d;
        text-shadow: 0px 0px 40px #ebefff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .level {
      margin-left: 20px;
      display: flex;
      align-items: center;
      .icon-level {
        width: 40px;
        height: 40px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        margin-right: 6px;
        object-fit: cover;
      }
      .level-text {
        font-size: 20px;
        color: #6c798c;
        text-shadow: 0px 0px 40px #ebefff;
      }
    }
  }
}
</style>
